"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyMapping = void 0;
var uuid_1 = require("uuid");
var error_messages_1 = require("../constants/error-messages");
var descriptors_1 = require("./descriptors");
var service_identifier_1 = require("./service-identifier");
/**
 * 用于将多种serviceId映射为同一种serviceId
 */
var KeyMapping = /** @class */ (function () {
    function KeyMapping() {
        // 一个key可能有多个mapping
        this.identifierMap = new Map();
        this.serviceKeyMap = new Map();
    }
    /**
     * 获取的ServiceIdentifier到ServiceKey映射
     * @param id
     * @returns
     */
    KeyMapping.prototype.getMapping = function (id) {
        var _this = this;
        var id2Keys = this.identifierMap.get(id);
        var keysList = [];
        id2Keys === null || id2Keys === void 0 ? void 0 : id2Keys.forEach(function (key) {
            if (_this.serviceKeyMap.get(key)) {
                keysList.push(key);
            }
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (id2Keys === undefined && typeof id === 'function' && typeof id.toLegacyString !== 'function') {
            if (this.serviceKeyMap.get(id)) {
                keysList.push(id);
            }
        }
        return keysList;
    };
    /**
     * 删除ServiceKey的所有mapping
     * @param mappingValue
     */
    KeyMapping.prototype.deleteMapping = function (mappingValue) {
        var _this = this;
        this.identifierMap.forEach(function (id2Keys) {
            var idx = id2Keys.indexOf(mappingValue);
            if (idx >= 0) {
                id2Keys.splice(idx, 1);
                _this.serviceKeyMap.delete(mappingValue);
            }
        });
    };
    /**
     * 清除所有mapping
     */
    KeyMapping.prototype.clear = function () {
        this.identifierMap.clear();
        this.serviceKeyMap.clear();
    };
    /**
       * 清除所有mapping
       */
    KeyMapping.prototype.dispose = function () {
        this.clear();
    };
    /**
     * 根据一定的策略生成ServiceIdentifier对应的ServiceKey
     * @param id
     * @param instanceOrDescriptor
     * @returns
     */
    KeyMapping.prototype.generateServiceKey = function (id, instanceOrDescriptor, append) {
        if (append === void 0) { append = false; }
        if (instanceOrDescriptor instanceof descriptors_1.SyncDescriptor) {
            return this.generateDescriptorKey(id, instanceOrDescriptor, append);
        }
        return this.generateValueInstanceKey(id, instanceOrDescriptor, append);
    };
    /**
     * 当映射内容为ValueObject时, 生成ServiceIdentifier对应的ServiceKey
     * @param id
     * @param valueInstance
     * @param append
     * @returns
     */
    KeyMapping.prototype.generateValueInstanceKey = function (id, valueInstance, append) {
        if (append === void 0) { append = false; }
        if (append) {
            var valueKeyId = this.createRandomValueKey(valueInstance);
            this.addMapping(id, valueInstance, { valueId: valueKeyId });
            return valueKeyId;
        }
        var id2Keys = this.getMapping(id);
        if (id2Keys.length === 0) {
            var valueKeyId = this.createRandomValueKey(valueInstance);
            this.addMapping(id, valueInstance, { valueId: valueKeyId });
            return valueKeyId;
        }
        if (id2Keys.length === 1) {
            var mappedKey = id2Keys[0];
            var mappingValue = this.serviceKeyMap.get(mappedKey);
            if (mappingValue === null || mappingValue === void 0 ? void 0 : mappingValue.override) {
                // 处理override模式下的key生成
                this.deleteMappingById(id, mappedKey);
                var valueKeyId = this.createRandomValueKey(valueInstance);
                this.addMapping(id, valueInstance, { valueId: valueKeyId });
                return valueKeyId;
            }
            return id2Keys[0];
        }
        // 非append模式下一个存在多个serviceIdentifier到serviceKey的map则抛出异常
        // eslint-disable-next-line new-cap
        throw new Error(error_messages_1.AMBIGUOUS_OVERRIDE_SERVICE(service_identifier_1.getIdentifierName(id)));
    };
    /**
     * 当映射内容为SyncDescriptor时, 生成ServiceIdentifier对应的ServiceKey
     * @param id
     * @param descriptor
     * @param append
     * @returns
     */
    KeyMapping.prototype.generateDescriptorKey = function (id, descriptor, append) {
        if (append === void 0) { append = false; }
        var id2Keys = this.getMapping(id);
        // multi inject模式下append为true
        if (append) {
            if (!(id2Keys === null || id2Keys === void 0 ? void 0 : id2Keys.includes(descriptor))) {
                this.addMapping(id, descriptor.ctor);
            }
            return descriptor.ctor;
        }
        if (id2Keys.length === 0) {
            this.addMapping(id, descriptor.ctor, { override: descriptor.supportsOverride });
            return descriptor.ctor;
        }
        if (id2Keys.length === 1) {
            var mappedKey = id2Keys[0];
            var mappingValue = this.serviceKeyMap.get(mappedKey);
            if ((mappingValue === null || mappingValue === void 0 ? void 0 : mappingValue.override) && descriptor.ctor !== mappedKey) {
                // 处理override模式下的key生成
                this.deleteMappingById(id, mappedKey);
                this.addMapping(id, descriptor.ctor, { override: descriptor.supportsOverride });
                return descriptor.ctor;
            }
            return id2Keys[0];
        }
        // 非append模式下一个存在多个serviceIdentifier到serviceKey的map则抛出异常
        // eslint-disable-next-line new-cap
        throw new Error(error_messages_1.AMBIGUOUS_OVERRIDE_SERVICE(service_identifier_1.getIdentifierName(id)));
    };
    /**
     * 添加新的ServiceIdentifier到ServiceKey映射
     * @param id 服务ID
     * @param ctorOrValue 服务构造函数或实例
     * @param options 服务辅助ID，用于值注入
     */
    KeyMapping.prototype.addMapping = function (id, ctorOrValue, options) {
        var id2Keys = this.identifierMap.get(id);
        if (options === null || options === void 0 ? void 0 : options.valueId) {
            var valueId = options.valueId;
            id2Keys ? id2Keys.push(valueId) : this.identifierMap.set(id, [valueId]);
            this.serviceKeyMap.set(valueId, { serviceKey: valueId });
        }
        else {
            id2Keys ? id2Keys.push(ctorOrValue) : this.identifierMap.set(id, [ctorOrValue]);
            this.serviceKeyMap.set(ctorOrValue, { serviceKey: ctorOrValue, override: options === null || options === void 0 ? void 0 : options.override });
        }
    };
    /**
     * 生成新的value key
     * @param valueInstance
     * @returns
     */
    KeyMapping.prototype.createRandomValueKey = function (valueInstance) {
        var valueKeyId = valueInstance.constructor.name + "@" + uuid_1.v4();
        return valueKeyId;
    };
    /**
     * 删除一条id到ServiceKey的mapping
     * @param id
     * @param mappingValue
     */
    KeyMapping.prototype.deleteMappingById = function (id, mappingValue) {
        // 检查多少个id映射到同一个ServiceKey
        var mappingCnt = 0;
        this.identifierMap.forEach(function (id2Keys) {
            var idx = id2Keys.indexOf(mappingValue);
            if (idx >= 0) {
                mappingCnt += 1;
            }
        });
        // 没有映射直接返回
        if (mappingCnt === 0) {
            return;
        }
        var serviceKeys = this.identifierMap.get(id);
        if (serviceKeys && serviceKeys.length) {
            var idx = serviceKeys.indexOf(mappingValue);
            if (idx >= 0) {
                serviceKeys.splice(idx, 1);
            }
            if (mappingCnt === 1) {
                this.serviceKeyMap.delete(mappingValue);
            }
        }
    };
    return KeyMapping;
}());
exports.KeyMapping = KeyMapping;
//# sourceMappingURL=key-mapping.js.map